export class CustomSelect {
  constructor() {
    this._selects = null;
    this._select = null;

    this._onSelectClick = this._onSelectClick.bind(this);
    this._onSelectKeydown = this._onSelectKeydown.bind(this);
    this._onSelectItemClick = this._onSelectItemClick.bind(this);
    this._onSelectItemKeydown = this._onSelectItemKeydown.bind(this);
    this._onLastSelectItemKeydown = this._onLastSelectItemKeydown.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._onEscapeKeydown = this._onEscapeKeydown.bind(this);
  }

  init() {
    this._selects = document.querySelectorAll('[data-select]');

    if (!this._selects.length) {
      return;
    }

    this._selects.forEach((select) => {
      this._setSelectAction(select);

      if (select.querySelector('[data-select-search]')) {
        this._initSearch(select);
      }
    });
  }

  _initSearch(select) {
    const search = select.querySelector('[data-select-search]');
    const input = search.querySelector('input');
    const items = select.querySelectorAll('[data-select-item]');

    input.addEventListener('input', (evt) => {
      evt.preventDefault();
      let isFound = false;
      let regex = new RegExp(`^${input.value.toLowerCase()}`);
      console.log(regex);

      items.forEach((item) => {
        if (!item.innerText.toLowerCase().match(regex)) {
          item.style.display = 'none';
        } else {
          item.style.display = 'block';
          isFound = true;
        }
      });

      if (!isFound) {
        select.classList.add('is-not-found');
      } else {
        select.classList.remove('is-not-found');
      }

      if (!input.value) {
        this._resetSearch(select);
      }
    });
  }

  _resetSearch(select, resetInput=null) {
    const search = select.querySelector('[data-select-search]');
    const input = search.querySelector('input');
    const items = select.querySelectorAll('[data-select-item]');

    if (resetInput) {
      input.value = '';
    }

    if (select.classList.contains('is-not-found')) {
      select.classList.remove('is-not-found');
    }

    items.forEach((item) => {
      item.style.display = 'block';
    });
  }

  _setSelectAction(select) {
    this._select = select;

    const button = this._select.querySelector('[data-select-button]');
    const buttonText = this._select.querySelector('[data-select-text]');
    const items = this._select.querySelectorAll('[data-select-item]');
    const selectTag = this._select.querySelector('select');
    const selectedOption = selectTag[selectTag.selectedIndex].text;

    buttonText.innerHTML = selectedOption;

    button.addEventListener('click', this._onSelectClick);
    button.addEventListener('keydown', this._onSelectKeydown);

    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        this._onSelectItemClick(item, index);
      });

      item.addEventListener('keydown', (evt) => {
        this._onSelectItemKeydown(item, index, evt);
      });

      if (index === items.length - 1) {
        item.addEventListener('keydown', this._onLastSelectItemKeydown);
      }
    });
  }

  _setSelectItemAction(item, index) {
    const parent = item.closest('[data-select]');
    const buttonText = parent.querySelector('[data-select-text]');
    const itemText = item.textContent;
    const select = parent.querySelector('select');
    const changeEvent = new CustomEvent('change');
    const inputEvent = new CustomEvent('input');
    select.dispatchEvent(changeEvent);
    select.dispatchEvent(inputEvent);
    const options = parent.querySelectorAll('option');
    const form = select.closest('form');

    if (form) {
      const formChangeEvent = new CustomEvent('change');
      const formInputEvent = new CustomEvent('input');
      form.dispatchEvent(formChangeEvent);
      form.dispatchEvent(formInputEvent);
    }

    const activeItem = parent.querySelector('[data-select-item][aria-selected="true"]');

    if (item.getAttribute('aria-selected') === true) {
      this._closeSelect();
    } else {
      if (activeItem) {
        activeItem.setAttribute('aria-selected', false);
      }

      item.setAttribute('aria-selected', 'true');
      buttonText.innerText = itemText;
      options[index + 1].selected = true;
      this._closeSelect();
    }
  }

  _closeSelect() {
    const activeSelect = document.querySelector('[data-select].is-open');

    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('click', this._onEscapeKeydown);

    if (activeSelect) {
      activeSelect.classList.remove('is-open');

      if (activeSelect.querySelector('input')) {
        this._resetSearch(activeSelect, true);
      }
    }
  }

  _onSelectClick(evt) {
    const parent = evt.target.closest('[data-select]');
    const activeSelect = document.querySelector('[data-select].is-open');

    if (activeSelect && activeSelect === parent) {
      activeSelect.classList.remove('is-open');
      return;
    }

    if (activeSelect) {
      this._closeSelect();
    }

    document.addEventListener('click', this._onDocumentClick);
    document.addEventListener('keydown', this._onEscapeKeydown);

    if (parent.classList.contains('is-open')) {
      parent.classList.remove('is-open');
    } else {
      parent.classList.add('is-open');
    }
  }

  _onSelectKeydown(evt) {
    const parent = evt.target.closest('[data-select]');
    if (evt.shiftKey && evt.key === 'Tab' && parent.classList.contains('is-open')) {
      this._closeSelect();
    }
  }

  _onSelectItemClick(item, index) {
    this._setSelectItemAction(item, index);
  }

  _onSelectItemKeydown(item, index, evt) {
    if (evt.key === 'Enter') {
      this._setSelectItemAction(item, index);
    }
  }

  _onLastSelectItemKeydown(evt) {
    if (evt.key === 'Tab') {
      this._closeSelect();
    }
  }

  _onDocumentClick(evt) {
    if (!evt.target.closest('[data-select]')) {
      this._closeSelect();
    }
  }

  _onEscapeKeydown(evt) {
    if (evt.key === 'Escape') {
      this._closeSelect();
    }
  }
}
